import React from 'react'
import './index.css'

const Index = ({Value, Action}) => {
  return (
    <div className='airiosoft_button_alt'>
      <button onClick={Action}>{Value}</button>
    </div>
  )
}

export default Index
